import PropTypes from 'prop-types';
import cn from 'classnames';
import Image from 'next/image';
import rehypeRaw from 'rehype-raw';
// Components
import { CTA, AnchorArrow } from 'react-scale/components';
import ReactMarkdown from 'react-markdown';
import dynamic from 'next/dynamic';

const DataSectionSlider = dynamic(() => import('./slider'), {
  ssr: false
});

const DataSection = ({
  icon,
  overtitle,
  title,
  description,
  link,
  cta,
  images,
  inverted,
  bleeds
}) => {
  const outerWrapperStyles = cn('flex justify-between items-center flex-col', {
    'xl:flex-row-reverse ': inverted,
    'xl:flex-row': !inverted
  });
  const wrapperStyles = cn({
    'xl:ml-16': inverted,
    'xl:mr-16': !inverted
  });

  return (
    <div className={outerWrapperStyles}>
      <div className="w-full xl:w-5/12 md:pb-11">
        <div className={wrapperStyles}>
          {icon && (
            <div>
              <Image src={icon.src} width={icon.w} height={icon.h} />
            </div>
          )}
          <span className="inline-block mt-4 text-neutral-300 text-overtitle-sm">{overtitle}</span>
          <h2 className="mt-4 text-3xl sm:text-5xl font-aeonik">{title}</h2>
          <ReactMarkdown
            rehypePlugins={[rehypeRaw]}
            className="pb-12 mt-6 text-lg text-neutral-300 border-b border-neutral-800"
          >
            {description}
          </ReactMarkdown>
          {link && (
            <div className="mt-8 xl:max-h-16">
              <AnchorArrow href={link.href} text={link.name} />
            </div>
          )}
          {cta && (
            <div className="mt-8 xl:max-h-16">
              <CTA cta={cta} center={false} />
            </div>
          )}
        </div>
      </div>
      <div className="w-full mt-16 xl:w-7/12 xl:mt-0">
        <DataSectionSlider images={images} inverted={inverted} bleeds={bleeds} />
      </div>
    </div>
  );
};

DataSection.propTypes = {
  icon: PropTypes.objectOf(PropTypes.shape),
  overtitle: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  link: PropTypes.objectOf(PropTypes.shape),
  cta: PropTypes.objectOf(PropTypes.shape),
  images: PropTypes.objectOf(PropTypes.shape),
  inverted: PropTypes.bool,
  bleeds: PropTypes.bool
};

DataSection.defaultProps = {
  icon: null,
  overtitle: '',
  title: '',
  description: '',
  link: null,
  cta: null,
  images: null,
  inverted: false,
  bleeds: false
};

export default DataSection;
